var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterpinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.572,
    height: 27.068,
    viewBox: "0 0 20.572 27.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_041-pinterest",
    "data-name": "041-pinterest",
    d: "M3.221,14.709c.034-.084.373-1.387.4-1.475a9.1,9.1,0,0,1-.666-5.519c.486-3.1,3.777-4.631,6.883-4.631V3.077c3.89,0,6.8,2.167,6.8,5.894,0,2.917-1.755,6.773-4.756,6.773h0A4.279,4.279,0,0,1,9.1,14.782,2.131,2.131,0,0,1,8.8,12.829a25.81,25.81,0,0,0,1.288-5.083,1.92,1.92,0,0,0-2.01-2.11A2.849,2.849,0,0,0,5.473,7.595,5.268,5.268,0,0,0,5.5,11.437c.193.541-.854,4.07-1.19,5.219-.833,2.854-1.974,6.466-1.73,8.477l.235,1.935L4,25.519c1.636-2.142,3.328-7.683,3.779-9.032,1.333,1.726,4.108,1.776,4.432,1.776,3.975,0,8.482-3.947,8.354-9.44C20.456,4,16.93,0,10.6,0V.006C4.57.006,1.053,3.222.192,7.286-.6,11.054,1.157,13.922,3.221,14.709Zm0,0",
    transform: "translate(0.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterpinterest);
export default __webpack_public_path__ + "static/media/footerpinterest.c3b2ae07e37827903b5a6076faf4f512.svg";
export { ForwardRef as ReactComponent };